import { Injectable } from '@angular/core';

import { BaseApiService } from '../base-api.service';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  token = '';
  public baseUrl = window.location.origin;

  constructor(
    private baseAPIService: BaseApiService,
    user: UserService,
  ) {
    user.token.subscribe(value => {
      this.token = value;
    });
  }

  getReports(): Promise<ReportResponse> {
    let url = this.baseUrl + '/api/Report/GetReports';
    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.get<ReportResponse>(url);
  }

  getReportUrl(id: string): Promise<string> {
    let url = this.baseUrl + '/api/Report/GetEmbedInfo?id=' + id;
    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.get<string>(url);
  }

  downloadDisputedCrossesReport() {
    const fileLoc = this.baseUrl + '/api/Report/DownloadDisputedCrossesReport';
    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.downloadFile(fileLoc);
  }
}

class ReportResponse {
  groups: ReportGroup[];
}

//create reports object
export class Report {
  public name: string;
  public id: string;
  public key: number;
  public route: string;
  public type: string;
}

export class ReportGroup {
  public groupName: string;
  public reports: Report[];
}
